import { Select } from 'antd';
import { LeftMenu } from '../Menu/left.menu';
import './report.css';
import { useState } from 'react';
import { ReportMCH } from './report.mch';
import { ReportSheet } from './report.sheet';
import { ReportDayPrecipitation } from './report.day-precipitation';
import { useAuth } from '../Auth/store';

const reportTypeItems = [
    {
        key: 'mch',
        label: 'Отчет по измерителю',
        value: 'mch'
    },
    {
        key: 'sheet',
        label: 'Ведомость',
        value: 'sheet'
    },
    {
        key: 'day_precipitation',
        label: 'Суточные осадки',
        value: 'day_precipitation'
    }
]

const DEFAULT_REPORT_TYPE = 'mch'

export const Report = () => {

    const {isAuth, permission} = useAuth()    

    const [reportType, setReportType] = useState(DEFAULT_REPORT_TYPE);
    const [disabled, setDisabled] = useState(false);

    const onChangeReportType = (item) => {
        setReportType(item);
    }

    const onStartReport = () => {
        setDisabled(true)
    }

    const onFinishReport = () => {
        setDisabled(false)
    }

    if (!isAuth || !permission?.permissions?.can_view_data_archive)
        return <></>

    return (
        <div className="report-body">
            <LeftMenu isShowMain={true}/>
            <Select
                options={reportTypeItems} 
                value={reportType}                
                className="w-100"           
                onChange={onChangeReportType}
                disabled={disabled}             
            />
            <div style={{width: 400}}>
                {reportType === 'mch' &&
                    <ReportMCH onStartReport={onStartReport} onFinishReport={onFinishReport}/>
                }    

                {reportType === 'sheet' &&
                    <ReportSheet onStartReport={onStartReport} onFinishReport={onFinishReport}/>
                }    

                {reportType === 'day_precipitation' &&
                    <ReportDayPrecipitation onStartReport={onStartReport} onFinishReport={onFinishReport} />
                }

            </div>

        </div>
    )
}